<template>
	<template v-if="loading"></template>
	<template v-else>
		<div class="c-menu__auth-buttons" v-if="!appData.loggedIn">
			<a :href="appData.register_url" class="c-menu__sign-up">
				<span class="c-button c-button--menu-auth">Sign Up</span>
			</a>
			<a class="c-button c-button--menu-auth c-button--menu-auth-inverse c-menu__log-in" :href="appData.login_url"
				>Log in</a
			>
		</div>

		<div class="c-account-menu" v-else v-click-outside="onClickOutside">
			<button class="c-account-menu__toggle" @click="open = !open" aria-label="Toggle account menu">
				<div class="c-account-menu__name">
					{{ appData.writer.name }}
				</div>
				<div class="c-account-menu__color" :style="{ '--color': `${appData.writer.color}` }"></div>
			</button>

			<nav class="c-account-menu__menu" v-if="open">
				<ul>
					<li v-for="menuItem in appData.menuItems">
						<a :href="menuItem.url">{{ menuItem.name }}</a>
					</li>
					<li class="c-account-menu__menu-button" v-if="appData.loggedIn">
						<button @click="logout">Log out</button>
					</li>
				</ul>
			</nav>
		</div>

		<Teleport to="[data-auth-menu-mobile]">
			<a
				class="c-button c-button--menu-auth c-button--menu-auth-variant"
				:href="appData.register_url"
				v-if="!appData.loggedIn"
				>Sign Up</a
			>
		</Teleport>
	</template>
</template>

<script>
import { callApi } from '../utils';
import vClickOutside from 'click-outside-vue3';

export default {
	name: 'AuthMenu',
	directives: {
		clickOutside: vClickOutside.directive,
	},
	data: function () {
		return {
			loading: true,
			appData: {},
			open: false,
			busy: false,
		};
	},
	watch: {
		'appData.loggedIn'(loggedIn) {
			if (loggedIn) {
				document.body.classList.add('app-logged-in');
			} else {
				document.body.classList.remove('app-logged-in');
			}
		},
	},
	created() {
		this.auth();
	},
	methods: {
		async auth() {
			this.appData = await callApi('account');
			this.loading = false;
		},
		async logout() {
			if (this.busy) {
				return;
			}

			this.busy = true;
			this.appData = await callApi('logout');
			this.busy = false;
		},
		onClickOutside() {
			this.open = false;
		},
	},
};
</script>

<style lang="scss" scoped></style>
